import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '@/modules/localizations';
import { Button, Heading, Icon, Text } from '@/modules/ui';

import { useTrialModal } from '../../../hooks';
import heroImage from '../assets/trialStartHeader.png';
import * as felaRules from './TrialStartContent.rules';

const features = ([1, 2, 3, 4] as const).map(id => `saas.premiumFeaturesTrial.features.${id}` as const satisfies MessageKey);

export const TrialStartContent = () => {
    const { css } = useFela();
    const { closeTrialModal } = useTrialModal();

    return (
        <>
            <img src={heroImage} alt='' className={css(felaRules.heroImage)} />
            <Heading variant='h2' color='foregroundsPrimary'>
                <FormattedMessage id='saas.premiumFeaturesTrial.title' />
            </Heading>

            <Text variant='ParagraphNormalRegular' color='foregroundsTertiary'>
                <FormattedMessage id='saas.premiumFeaturesTrial.text.1' />
            </Text>

            <Heading variant='h3' color='foregroundsPrimary'>
                <FormattedMessage id='saas.premiumFeaturesTrial.features.title' />
            </Heading>

            <Text variant='ParagraphNormalRegular' color='foregroundsTertiary' elementType='ul' className={css(felaRules.featuresList)}>
                {features.map(feature => (
                    <li key={feature} className={css(felaRules.featuresListItem)}>
                        <Icon type='checkmark' color='iconsTertiary' />
                        <FormattedMessage id={feature} />
                    </li>
                ))}
            </Text>

            <Text variant='ParagraphNormalRegular' color='foregroundsTertiary'>
                <FormattedMessage id='saas.premiumFeaturesTrial.text.2' />
            </Text>

            <div className={css(felaRules.buttonsContainer)}>
                <Button type='primary' onClick={() => closeTrialModal('start')}>
                    <FormattedMessage id='saas.premiumFeaturesTrial.button.primary' />
                </Button>
            </div>
        </>
    );
};
